import { lookupStateName } from 'utils/getLocations'
import { ILocationSuggestion } from '../types'

/**
 * @example getLocationLabel({ state: 'NY' }) // 'New York'
 */
export const getLocationLabel = (location: ILocationSuggestion): string => {
  const { city, postalCode, resultType, state } = location || {}

  if (!state) {
    return ''
  }

  if (!city) {
    return lookupStateName(state)
  }

  if (resultType === 'PostalCode') {
    const locationName = [city, lookupStateName(state)].join(', ')
    return [postalCode, locationName].join(' • ')
  }

  return [city, lookupStateName(state)].join(', ')
}
